require('./style.less');

var Marionette = require('marionette'),
    Backbone = require('backbone');

var NavBar = require('./navBar/view');

module.exports = Marionette.LayoutView.extend({
    template: require('./template.hbs'),
    regions: {
        navBar: '.FV-region-navBar'
    },
    serializeData: function () {
        var vCh = this.options.vChannel,
            nDocs = vCh.request('documents').length,
            activeDocIndex = vCh.request('activeDocIndex');
        return {
            showDocNavigation: nDocs > 1,
            showPrevDocBtn: activeDocIndex !== 0,
            showNextDocBtn: activeDocIndex !== nDocs - 1
        };
    },
    ui: {
        docNavBtn: '.FV-docNavBtn'

    },
    events: {
        'click @ui.docNavBtn': function (e) {
            this.options.vChannel.command('changeActiveDoc', $(e.currentTarget).attr('title')); //todo: mediate...
        }
    },
    onRender: function () {
        // Backbone.View.prototype.unwrap.call(this); //todo: note: unwrap will break the already attached ui -- just leave
        var vCh = this.options.vChannel;
        this.navBar.show(
            new NavBar({
                activeDoc: vCh.request('activeDocument'),
                docCollection: vCh.request('documents'),
                vChannel: vCh,
                vContainer: this.$el //must be in region / 'layout not yet shown'
            })
        );
    },
    onAttach: function () {
        //do on attach for positioning sizing of dd
        this.ui.docNavBtn.each(function () { //todo: make plugin support multi element ...
            $(this).iframeShim();
        });
        /* must be in DOM to size */
    },
    toggleDocNavInterfaces: function (show) {
        this.navBar.currentView.toggleNavigability(show);
        this.ui.docNavBtn.toggleClass('hide', !show);
    },
    onBeforeDestroy: function () {
        /*Note: on before destroy would only because after this from layout sub app destroy */
        this.ui.docNavBtn.each(function () { //todo: make plugin support multi element ...
            $(this).iframeShim('destroy');
        });
        /* must be in DOM to size */
        this.ui.docNavBtn.remove();
        /* quick fix for jq cache refs */
        this.$('*').remove();
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/view.js
 ** module id = 691
 ** module chunks = 0
 **/